export const visit = (vm, at) => {
at({ "es": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "\xBFTienes problemas para ver este video?", "playButton": "Reproducir" } } });
};